export default "__VITE_ASSET__5741dcb2__"